<template>
    <b-navbar toggleable="lg" class="p-0">
        <b-navbar-brand :to="{ name: 'home' }">
            <a href="/">
                <!-- hide on screens wider than sm -->
                <img
                    class="d-sm-none"
                    src="../../assets/images/energyspace-logo-mobile.png"
                    alt="Repower Logo"
                    height="26"
                />
                <!-- hide on screens smaller than sm -->
                <img
                    class="d-none d-sm-block"
                    v-if="['production', 'internal'].includes(config.environmentName)"
                    src="../../assets/images/energyspace-logo-desktop.png"
                    alt="Repower Logo"
                    width="150"
                />
                <img
                    class="d-none d-sm-block"
                    v-else
                    src="../../assets/images/energyspace-logo-desktop.png"
                    alt="Repower Logo"
                    width="150"
                />
            </a>
        </b-navbar-brand>

        <b-navbar-toggle target="collapse-main-nav" />
        <b-collapse v-show="isUserAuthenticated" id="collapse-main-nav" is-nav>
            <!-- App navigation: align to the left -->
            <b-navbar-nav v-show="navbarItems && navbarItems.length > 0">
                <b-nav-item
                    v-for="item in navbarItems"
                    :key="item.id"
                    :to="{ name: item.routeName }"
                    :active="isActiveRoute(item)"
                >
                    {{ item.name }}
                </b-nav-item>
            </b-navbar-nav>

            <!-- Common navigation: right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item v-show="title" :to="{ name: 'home' }">{{ title }}</b-nav-item>
                <b-nav-item v-show="config.showPortalLink" v-on:click="gotoPortal()">
                    <font-awesome-icon icon="home" fixed-width title="Home" size="lg" class="mr-1" />Home</b-nav-item
                >
                <b-nav-item v-show="isUserAuthenticated" v-on:click="logout()"
                    ><font-awesome-icon
                        icon="right-from-bracket"
                        fixed-width
                        title="Logout"
                        size="lg"
                        class="mr-1"
                    />Logout</b-nav-item
                >
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import { mapGetters } from "vuex";
import ReNavbar from "../ReNavbar/ReNavbar";

export default {
    name: "ReNavbarTop",
    props: {
        /**
         * A boolean that says if a user is authenticated.
         * If you use vuex-oidc library you can pass the "oidcIsAuthenticated" getter
         */
        isUserAuthenticated: {
            type: Boolean,
            required: true,
            default: false,
        },
        /**
         * The menu configuration object.
         * See ReMenu documentation.
         * Properties required:
         * - username: {string} the username displayed in the menu (EG: "matteo.galli") - NOT USED ANYMORE
         * - accessToken: {string} the access token used as API Bearer token while communicatin with apiMiPortal - NOT USED ANYMORE
         * - apiServerPrefix: {string} the URL of the API server (EG: "https://rbmidde02.corp.repower.com/Api") - NOT USED ANYMORE
         * - environmentName: {string} the current environment name. Must be one of: ["development", "integration", "staging", "production"] - MANDATORY
         * - hideMenuIcon: {boolean} if true hide the "Menu" icon - OPTIONAL
         */
        config: {
            type: Object,
            required: true,
        },
        /**
         * The configuration for the application menu (optional).
         * Must be and array of object, for example:
         * {
         *     id: "power",
         *     name: "Power Page",
         *     routeName: "power"
         * }
         */
        navbarItems: {
            type: Array,
            required: false,
        },
        /**
         * A string representing the current route.
         * It should match one of: navbarItems[i].routeName
         */
        routeName: {
            type: String,
            required: false,
        },
        /**
         * A {string} representing the title near the burger menu.
         */
        title: {
            type: String,
            required: false,
        },
    },
    computed: {
        ...mapGetters({
            isEditorUser: "isEditorUser",
            oidcIsAuthenticated: "oidcIsAuthenticated",
            storeMakBasket: "mak/basket",
        }),
    },
    methods: {
        logout() {
            this.$emit("onLogout");
        },
        async gotoPortal() {
            this.$emit("onGotoPortal");
        },
        isActiveRoute(item) {
            if (!this.routeName) {
                return false;
            }
            return item.routeName === this.routeName;
        },
    },
};
</script>
